const CUSTOMER_CONVERSATION_BASE_ROUTES = new Set([
	'inbox',
	'unassigned',
	'my-messages',
	'locations',
	'folders',
	'users',
	'tags',
	'departments',
]);

export const isTeamConversationPath = (pathname = '') =>
	pathname.includes('/conversation/groups');

export const buildCanonicalCustomerConversationPath = ({
	_customerConversation,
	_business,
}) =>
	buildCustomerConversationPath({
		basePath: '/inbox',
		_customerConversation,
		_business,
	});

export const buildCustomerConversationPath = ({
	basePath = '/inbox',
	_customerConversation,
	_business,
}) => {
	const normalizedBasePath = normalizeCustomerConversationBasePath(basePath);
	const locationQuery = _business
		? `?_location=${encodeURIComponent(_business)}`
		: '';

	return `${normalizedBasePath}/conversation/${_customerConversation}${locationQuery}`;
};

export const buildContextualCustomerConversationPath = ({
	pathname,
	_customerConversation,
	_business,
}) =>
	buildCustomerConversationPath({
		basePath: getCustomerConversationBasePath(pathname),
		_customerConversation,
		_business,
	});

export const buildLegacyCustomerConversationRedirectPath = ({
	pathname = '',
	_business,
}) => {
	if (!pathname.startsWith('/conversation/') || isTeamConversationPath(pathname)) {
		return null;
	}

	const [, , _customerConversation] = pathname.split('/');

	if (!_customerConversation) {
		return null;
	}

	return buildCanonicalCustomerConversationPath({
		_customerConversation,
		_business,
	});
};

export const getCustomerConversationBasePath = (pathname = '') => {
	const [firstSegment, secondSegment] = pathname.split('/').filter(Boolean);

	if (!firstSegment || !CUSTOMER_CONVERSATION_BASE_ROUTES.has(firstSegment)) {
		return '/inbox';
	}

	if (['inbox', 'unassigned', 'my-messages'].includes(firstSegment)) {
		return `/${firstSegment}`;
	}

	return secondSegment ? `/${firstSegment}/${secondSegment}` : '/inbox';
};

// The list screen a phone goes back to from a thread or compose: the filtered
// inbox view the conversation was opened from, or the team chat list.
export const getConversationListPath = (pathname = '', search = '') => {
	if (pathname.startsWith('/groupchat/dms')) {
		return '/groupchat/dms';
	}

	if (pathname.startsWith('/groupchat')) {
		return '/groupchat/groups';
	}

	if (isTeamConversationPath(pathname)) {
		return new URLSearchParams(search).get('isDirectMessage') === 'true'
			? '/groupchat/dms'
			: '/groupchat/groups';
	}

	return getCustomerConversationBasePath(pathname);
};

const normalizeCustomerConversationBasePath = (basePath) => {
	if (!basePath || basePath === '/') {
		return '/inbox';
	}

	return basePath.endsWith('/') ? basePath.slice(0, -1) : basePath;
};
